import { IconButton } from "@mui/material";
import downloadInProgressTransactionsExcel from "../../../common/downloadInProgressTransactionsExcel";
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';

const InProgressTransactionButton = () => {
  const handleDownload = () => {
    downloadInProgressTransactionsExcel()
  }
  
  return (
    <IconButton
      sx={{
        color: '#fc7f04'
      }}
      onClick={handleDownload}
    >
      <PublishedWithChangesIcon />
    </IconButton>
  )
}

export default InProgressTransactionButton;
